import { Component } from '@angular/core';

import { ModalController, NavParams, IonicPage, ViewController } from 'ionic-angular';

import { SyncServerServiceProvider } from '../../providers/sync-server-service/sync-server-service';
import { PermissionsService } from '../../providers/permissions-service/permissions-service';

import * as _ from 'lodash'

@IonicPage({ name: 'FormsFilterPage' })
@Component({
    selector: 'page-forms-filter',
    templateUrl: './forms-filter.html'
})
export class FilterFormsModalPage {
    pageSize = 20;
    roleLevel = 1;
    sections = {
        // default one of the views open
        users: false,
        projects: false,
        materials: false,
        date: false,
        statuses: false,
        sort: true
    };
    displayValues = {
        users: [],
        projects: [],
        materials: [],
        statuses: []
    };
    selectedValues = {
        users: [],
        projects: [],
        materials: [],
        date: {
            type: '',
            value: ''
        },
        statuses: [],
        sort: {
            type: '',
            value: ''
        }
    };
    searches = {
        users: {
            term: '',
            previousTerm: null,
            page: 1,
            pages: [],
            totalItems: 0,
            totalPages: 0
        },
        projects: {
            term: '',
            previousTerm: null,
            page: 1,
            pages: [],
            total: 0,
            totalPages: 0
        },
        materials: {
            term: '',
            previousTerm: null,
            page: 1,
            pages: [],
            total: 0,
            totalPages: 0
        },
        statuses: {
            term: '',
            previousTerm: null,
            page: 1,
            pages: [],
            total: 0,
            totalPages: 0
        },
    };
    showMaterials;
    displayName = 'Form';

    constructor(
        private syncService: SyncServerServiceProvider,
        public modalCtrl: ModalController,
        public navParams: NavParams,
        private viewCtrl: ViewController,
        private permissionService: PermissionsService
    ) {
        // gonna need href to figure out where we're filtering from
        // to turn on/off filters
        //console.log('location', window.location.href);

        // don't show materials on forms list (but we do use this on the samples list and other future places)
        this.showMaterials = (window.location.href.substr(window.location.href.length - 5) !== 'forms');
        this.roleLevel = this.permissionService.checkRolePermission();
    }

    ngOnInit() {
        if (this.navParams.get('filters')) {
            var tempFilters = this.navParams.get('filters');

            if (tempFilters.date) {
                this.selectedValues.date = tempFilters.date;
            }
            if (tempFilters.projects) {
                this.selectedValues.projects = tempFilters.projects;
            }
            if (tempFilters.users) {
                this.selectedValues.users = tempFilters.users;
            }
            if (tempFilters.materials) {
                this.selectedValues.materials = tempFilters.materials;
            }
            if (tempFilters.statuses) {
                this.selectedValues.statuses = tempFilters.statuses;
            }
            if (tempFilters.sort) {
                this.selectedValues.sort = tempFilters.sort;
            }
        }
        if (this.navParams.get('displayName')) {
            this.displayName = this.navParams.get('displayName');
        }
        // get first pages
        this.search('users');
        this.search('projects');
        this.search('materials');
        this.search('statuses');
    }


    getTotal(type, scope ?) {
        if (type === 'statuses') {
            return;
        }
        var filterChunks = [];

        if (this.searches[type].term) {
            filterChunks.push(`FOP~0~0~0`);
            if (type === 'users') {
                filterChunks.push(`FBV~NameFirst~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
                filterChunks.push(`FBVOR~NameLast~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
                filterChunks.push(`FCP~0~0~0`);
                filterChunks.push(`FSF~NameFirst~ASC~0`);
            } else if (type === 'projects' || type === 'materials') {
                filterChunks.push(`FBV~Name~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
                filterChunks.push(`FCP~0~0~0`);
                filterChunks.push(`FSF~Name~ASC~0`);
            }
        }
        var filter = `/FilteredTo/${filterChunks.join('~')}`;
        filter = filter.length > 12 ? filter : '';
        console.log('Filter:', filter)
        this.syncService.getTotalCount(_.capitalize(type), filter, `${type}Count`)
            .then(count => {
                this.searches[type].total = count;
                // this.totalCountDisplay = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // get the total page count
                this.searches[type].totalPages = Math.ceil(this.searches[type].total / this.pageSize);
                this.searches[type].pages = _.range(1, (this.searches[type].totalPages + 1));
                console.log(`[List view] ${type}`, this.searches[type], count);
            })
            .catch((err) => {
                console.log(err);
                // this.errorChandler(err);
            });
    }
    async search(type) {

        var filters = [];
        var filter;
        var tempPage = this.searches[type].page -1;

        this.getTotal(type);
        if (type === 'users') {
            let usersToDisplay = []

            if (tempPage === 0) {
                this.getTotal(type);

                if (this.selectedValues.users) {
                    const userIDs = this.selectedValues.users;
                    const filter = `FBL~IDUser~INN~${userIDs.join()}`;
                    const userRecs: any = await this.syncService.getUsersPaged(filter, (tempPage * this.pageSize), this.pageSize, 'UserGet');
                    if (userRecs && userRecs.length) {
                        _.each(userRecs, (user) => {
                            user._selected = true;
                            usersToDisplay.push(user);
                        });
                    }
                }
            }
            if (this.searches[type].term.length) {
                filters.push(`FOP~0~0~0`);
                filters.push(`FBV~NameFirst~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
                filters.push(`FBVOR~NameLast~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
                filters.push(`FCP~0~0~0`);
            }
            // Filter out the disabled users (these have a 'zzz' in their first name)
            filters.push(`FBV~Disabled~EQ~0~FSF~NameFirst~ASC~0`);
            filter = filters.join('~');
            // pass in a type to call its function and get the promise back
            const userResults:any = await this.syncService.getUsersPaged(filter, (tempPage * this.pageSize), this.pageSize, 'UserGet');
            if (userResults && userResults.length) {
                _.each(userResults, (user) => {
                    if (!_.find(usersToDisplay, {'Hash': user.Hash})) {
                        usersToDisplay.push(user);
                    }
                });
                this.displayValues[type] = usersToDisplay;

                // Show the selected users at the top
                this.displayValues[type].sort((a,b) => b._selected-a._selected);
            }

    } else if (type === 'projects') {
            if (tempPage === 0) {
                this.getTotal('projects');
            }
            if (this.searches[type].term.length) {
                // if (!this.searches[type].previousTerm || this.searches[type].previousTerm !== this.searches[type].term) {
                //   this.searches[type].previousTerm = this.searches[type].term;
                //   this.getTotal('projects');
                // }
                filters.push(`FBV~Name~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
            }
            filters.push(`FSF~Name~ASC~0`);
            filter = filters.join('~');
            await this.syncService.getProjectsPaged(filter, (tempPage * this.pageSize), this.pageSize)
                .then((projectResults: any) => {
                    if (projectResults && projectResults.length) {
                        _.each(projectResults, (project, index) => {
                            if (this.selectedValues.projects.indexOf(project.IDProject) > -1) {
                                projectResults[index]._selected = true;
                            }
                        });
                        this.displayValues[type] = projectResults;
                    }
                });
        } else if (type === 'materials') {
            if (tempPage === 0) {
                this.getTotal('materials');
            }
            if (this.searches[type].term.length) {
                // if (!this.searches[type].previousTerm || this.searches[type].previousTerm !== this.searches[type].term) {
                //   this.searches[type].previousTerm = this.searches[type].term;
                //   this.getTotal('materials');
                // }
                filters.push(`FBV~Name~LK~%25${encodeURIComponent(this.searches[type].term)}%25`);
            }
            filters.push(`FSF~Name~ASC~0`);
            filter = filters.join('~');
            await this.syncService.checkMaterials(filter, (tempPage * this.pageSize), this.pageSize)
                .then((materialResults: any) => {
                    if (materialResults && materialResults.length) {
                        _.each(materialResults, (material, index) => {
                            if (this.selectedValues.materials.indexOf(material.IDMaterial) > -1) {
                                materialResults[index]._selected = true;
                            }
                        });
                        this.displayValues[type] = materialResults;
                    }
                });
        } else if (type === 'statuses') {
            filters.push(`FBV~Status~NE~~`);
            filter = filters.join('~');
            await this.syncService.getDistinctSampleStatuses(filter)
                .then((statuses: any) => {
                    if (statuses && statuses.length) {
                        _.each(statuses, (status, index) => {
                            if (this.selectedValues.statuses.indexOf(status.Status) > -1) {
                                statuses[index]._selected = true;
                            }
                        });
                        this.displayValues[type] = statuses;
                    }
                });
        }
    }
    selectItem(type, item) {
        // TODO: this can probably cleaned up to better handle more filters
        if (this.selectedValues[type].indexOf(item.Hash || item.IDProject || item.IDMaterial || item.Status) < 0) {
            item._selected = true;
            this.selectedValues[type].push(item.Hash || item.IDProject || item.IDMaterial || item.Status);
        } else {
            item._selected = false;
            _.remove(this.selectedValues[type], (selectedItem) => {
                return selectedItem === (item.Hash || item.IDProject || item.IDMaterial || item.Status);
            });
        }
    }
    collapse(targetSection) {
        _.each(this.sections, (status, key) => {
            if (targetSection !== key) {
                // close other sections
                this.sections[key] = false;
            } else {
                this.sections[targetSection] = !this.sections[targetSection];
            }
        });
    }
    resetFilters() {
        this.selectedValues = {
            users: [],
            projects: [],
            materials: [],
            date: {
                type: '',
                value: ''
            },
            statuses: [],
            sort: {
                type: '',
                value: ''
            }
        };
        // Set values as false
        _.each(['users', 'projects', 'materials', 'statuses'], (type) => {
            _.each(this.displayValues[type], (item, index) => {
                item._selected = false;
                this.displayValues[type]._selected = false;
            });
        });
    }
    loadBack(type) {
        if (this.searches[type].page > 1) {
            this.searches[type].page--;
            this.search(type);
        }
    }
    goToPage(type, num) {
        if (num === this.searches[type].page) {
            return false;
        }

        this.searches[type].page = num;
        this.search(type);
    }
    loadNext(type) {
        if (this.searches[type].page < this.searches[type].totalPages) {
            this.searches[type].page++;
            this.search(type);
        }
    }
    cancel() {
        this.viewCtrl.dismiss('cancel');
    }
    doFilter() {
        console.log('doFilter');
        this.viewCtrl.dismiss(this.selectedValues);
    }
}



// WEBPACK FOOTER //
// ./src/pages/forms/forms-filter.ts